<script>
  import ContactPage from '$lib/pages/ContactPage.svelte';
</script>

<ContactPage />

